import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormArray } from '@angular/forms';

import { Subscription } from 'rxjs';

import { ShipmentService } from '../shipment.service';

@Component({
   selector: 'shipment-tradeshow',
   templateUrl: './tradeshow.component.html',
   styleUrls: ['./tradeshow.component.scss']
})
export class TradeshowComponent implements OnInit, OnDestroy {

   tradeshow: FormArray;

   shipmentSub: Subscription;

   config;

   document = document;

   constructor( public shipment: ShipmentService, ) { }

   ngOnInit() {
      this.shipmentSub = this.shipment.shipmentForm$.subscribe( s => this.tradeshow = s.get( 'tradeshow' ) as FormArray );
      this.config = this.shipment.configs?.tradeshow;
   }

   ngOnDestroy() {
      this.shipmentSub.unsubscribe();
   }
}
